<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['产品管理', '达人']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row class="common-row">
          <el-col :span="4">
            <span class="search-text">达人名称：</span>
            <el-input class="search-item" clearable placeholder="请输入" v-model="fullName" size="small"></el-input>
          </el-col>
          <el-col :span="4">
            <span class="search-text">名称：</span>
            <el-input class="search-item" clearable placeholder="请输入" v-model="name" size="small"></el-input>
          </el-col>
          <el-col :span="4">
            <span class="search-text">状态：</span>
            <el-select v-model="status" placeholder="请选择" class="search-item" clearable size="small">
              <el-option v-for="item in statuses" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <span class="search-text">一级分类：</span>
            <el-select v-model="firstCategory" placeholder="请选择" clearable class="search-item" @change="changOne" size="small">
              <el-option
                  v-for="item in brandCategoryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <span class="search-text">二级分类：</span>
            <el-select v-model="secondCategory" placeholder="请选择" clearable class="search-item" size="small">
              <el-option
                  v-for="item in categoryByTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <span class="search-text">审核人：</span>
            <el-select v-model="reviewedById" placeholder="请选择审核人" clearable class="search-item" size="small">
              <el-option
                  v-for="item in sysUserList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <span class="search-text">审核类型：</span>
            <el-select v-model="auditType" placeholder="请选择审核类型" clearable class="search-item" size="small">
              <el-option
                  v-for="item in auditTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <!--          <el-col :span="4">-->
          <!--            <span class="search-text">上下架状态：</span>-->
          <!--            <el-select v-model="shelfStatus" placeholder="请选择上下架状态" clearable class="search-item">-->
          <!--              <el-option-->
          <!--                  v-for="item in shelfStatusList"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.label"-->
          <!--                  :value="item.value"-->
          <!--              >-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </el-col>-->
          <el-col :span="4">
            <el-button class="btn-search" round icon="el-icon-search" @click="search" size="small"
                       v-if="hasPerm('cyberStar-search')">查询</el-button>
            <el-button type="warning" round icon="el-icon-refresh" @click="reset" size="small"
                       v-if="hasPerm('cyberStar-reset')">重置</el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row>
          <el-col :span="12">
            <el-button class="btns-add" icon="el-icon-plus" size="small" @click="add"
                       v-if="hasPerm('cyberStar-add')">添加</el-button>
            <el-button :disabled="selectData.length === 0" type="danger" icon="el-icon-delete" size="small"
                       @click="deleteMore" v-if="hasPerm('cyberStar-batch-delete')">批量删除</el-button>
            <el-button :disabled="exportLoading" type="warning" icon="el-icon-sell" size="small"
                       v-if="hasPerm('cyberStar-export')" @click="exportAll">{{ exportLoading ? '正在导出中...' :
                '全部导出'
              }}</el-button>
            <el-button :disabled="selectData.length === 0" type="primary" icon="el-icon-edit-outlin" size="small"
                       @click="verifyMore" v-if="hasPerm('cyberStar-batch-verify')">批量审核</el-button>
          </el-col>
        </el-row>
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" class="flex-1" stripe height="100%" border style="width: 100%"
                    @selection-change="selectRow" @sort-change="sortChange">
            <el-table-column type="selection" width="60px" align="center" fixed> </el-table-column>
            <el-table-column prop="fullName" align="center" show-overflow-tooltip label="达人机构名称" min-width="240">
            </el-table-column>
            <el-table-column prop="name" align="center" show-overflow-tooltip label="名称" width="240">
            </el-table-column>
            <el-table-column prop="banner" align="center" label="达人图片" width="150">
              <template v-slot="scope">
                <el-image v-if="scope.row.photo" style="height: 100px" :src="scope.row.photoSrc"
                          :preview-src-list="scope.row.photoList" fit="contain"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="firstCategory" align="center" show-overflow-tooltip label="品类" width="280">
              <template v-slot="scope">
                {{ getCategory(scope.row.firstCategory, scope.row.secondCategory) }}
              </template>
            </el-table-column>
            <el-table-column prop="status" align="center" show-overflow-tooltip label="状态" width="160">
              <template v-slot="scope">
                <span v-if="scope.row.status === '2'">通过</span>
                <span v-else-if="scope.row.status === '3'" class="reject-btns"
                      @click="checkRejectReason(scope.row.reason)">查看驳回原因</span>
                <span v-else>待审核</span>
              </template>
            </el-table-column>
            <el-table-column prop="auditType" width="180" align="center" label="审核类型"></el-table-column>
            <el-table-column prop="reviewedByName" width="200" align="center" label="审核人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="clientTime" sortable="custom" width="180" label="机构操作时间" align="center"></el-table-column>
            <el-table-column prop="serverTime" sortable="custom" width="180" label="平台操作时间" align="center"></el-table-column>
            <el-table-column prop="createTime" sortable="custom" width="180" label="创建时间" align="center"></el-table-column>
            <!--            <el-table-column prop="shelfStatus" align="center" show-overflow-tooltip width="140" label="上下架状态">-->
            <!--              <template v-slot="scope">-->
            <!--                {{ scope.row.shelfStatus === '1' ? '上架' : '下架' }}-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column align="center" width="220" label="操作" fixed="right">
              <template v-slot="scope">
                <div class="btn-box">
                  <el-button icon="el-icon-edit" type="text" @click="edit(scope.row.id)" size="small"
                             v-if="hasPerm('cyberStar-edit')">编辑</el-button>
                  <el-button icon="el-icon-document-checked" type="text"
                             @click="verify(scope.row.id, scope.row.status, scope.row.reason)" size="small"
                             v-if="hasPerm('cyberStar-verify')">审核</el-button>
                  <el-button icon="el-icon-delete" type="text" @click="deleteInfo(scope.row.id)" size="small"
                             v-if="hasPerm('cyberStar-delete')">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
                         :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next, sizes"
                         :total="total">
          </el-pagination>
        </el-row>
      </el-card>
    </div>
    <el-dialog title="审核" width="30%" :visible.sync="dialogShow" :close-on-click-modal="false" :show-close="false"
               @close="cancel">
      <el-form :model="verifyForm" :rules="verifyRules" ref="verifyForm" label-width="100px">
        <el-form-item label="审核" prop="status">
          <el-radio-group v-model="verifyForm.status" @change="verifySelect">
            <el-radio label="2">审核通过</el-radio>
            <el-radio label="3">审核驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因" v-if="verifyForm.status === '3'" prop="reason">
          <el-checkbox-group v-model="checkList" @change="selectRemark">
            <el-checkbox v-for="(item, index) of selectCheckList" :label="item.reason" :key="index"></el-checkbox>
          </el-checkbox-group>
          <el-input type="textarea" v-model="verifyForm.reason" :rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
    <previewDialog v-model="previewShow" />
    <transition name="phone">
      <div class="phone-box" v-if="onlineShow" @click="onlineShow = false">
        <!-- <transition name="phone"> -->
        <iphoneX v-model="onlineShow" :src="onlineUrl" />
      </div>
    </transition>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'
import verifyDialog from '../../components/verifyDialog.vue'
import previewDialog from '../../components/previewDialog.vue'
import iphoneX from '../../components/iphonex.vue'

export default {
  data () {
    return {
      exportLoading: false,
      onlineUrl: '',
      ids: '',
      name: '',
      address: '',
      firstCategory: '',
      secondCategory: '',
      category: '',
      auditType: '',
      reviewedById: '',
      shelfStatus: '',
      fullName: '',
      status: '',
      checkList: [],
      selectCheckList: [],
      statuses: [
        {
          label: '待审核',
          value: '1'
        },
        {
          label: '通过',
          value: '2'
        },
        {
          label: '驳回',
          value: '3'
        }
      ],
      sendSample: '',
      sendSamples: [
        {
          name: '可以寄样',
          id: '1'
        },
        {
          name: '可以参观/看样',
          id: '2'
        },
        {
          name: '可供产品资料',
          id: '3'
        },
        {
          name: '以上都不支持',
          id: '4'
        }
      ],
      selectData: [],
      tableData: [],
      tableHeight: 0,
      dialogShow: false,
      verifySrc: '',
      verifyStatus: '',
      reason: '',
      previewShow: false,
      onlineShow: false,
      verifyForm: {
        status: '1',
        reason: ''
      },
      verifyRules: {
        status: [
          {
            required: true, message: '请选择状态', trigger: 'blur'
          }
        ],
        reason: [
          {
            required: true, message: '请填写理由', trigger: 'blur'
          }
        ]
      },
      brandCategoryList: [],
      currentPage: 1,
      pageSize: 10,
      total: 1,
      orderData: {
        clientTimeOrder: '',
        serverTimeOrder: ''
      },
      categoryByTypeList: [],
      sysUserList: [],
      auditTypeList: [
        {
          label: '自动审核',
          value: '2'
        },
        {
          label: '人工审核',
          value: '1'
        }
      ],
      shelfStatusList: [
        {
          label: '上架',
          value: '1'
        },
        {
          label: '下架',
          value: '2'
        }
      ]
    }
  },
  components: {
    navHeader,
    verifyDialog,
    previewDialog,
    iphoneX
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'CyberStarDetail') {
      sessionStorage.setItem('currentPage', this.currentPage)
      sessionStorage.setItem('pageSize', this.pageSize)
      sessionStorage.setItem('chineseName', this.name)
      sessionStorage.setItem('fullName', this.fullName)
      sessionStorage.setItem('status', this.status)
      sessionStorage.setItem('sendSample', this.sendSample)
      sessionStorage.setItem('address', this.address)
      sessionStorage.setItem('category', this.category)
      sessionStorage.setItem('firstCategory', this.firstCategory)
      sessionStorage.setItem('secondCategory', this.secondCategory)
      sessionStorage.setItem('auditType', this.auditType)
      sessionStorage.setItem('reviewedById', this.reviewedById)
      sessionStorage.setItem('shelfStatus', this.shelfStatus)
      sessionStorage.setItem('orderData', JSON.stringify(this.orderData))
    } else {
      sessionStorage.removeItem('currentPage')
      sessionStorage.removeItem('pageSize')
      sessionStorage.removeItem('chineseName')
      sessionStorage.removeItem('fullName')
      sessionStorage.removeItem('status')
      sessionStorage.removeItem('sendSample')
      sessionStorage.removeItem('address')
      sessionStorage.removeItem('category')
      sessionStorage.removeItem('firstCategory')
      sessionStorage.removeItem('secondCategory')
      sessionStorage.removeItem('auditType')
      sessionStorage.removeItem('reviewedById')
      sessionStorage.removeItem('shelfStatus')
      sessionStorage.removeItem('orderData')
    }
    next()
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 440
    if (sessionStorage.getItem('currentPage')) this.currentPage = Number(sessionStorage.getItem('currentPage'))
    if (sessionStorage.getItem('pageSize')) this.pageSize = Number(sessionStorage.getItem('pageSize'))
    if (sessionStorage.getItem('chineseName')) this.name = sessionStorage.getItem('chineseName')
    if (sessionStorage.getItem('fullName')) this.fullName = sessionStorage.getItem('fullName')
    if (sessionStorage.getItem('status')) this.status = sessionStorage.getItem('status')
    if (sessionStorage.getItem('sendSample')) this.sendSample = sessionStorage.getItem('sendSample')
    if (sessionStorage.getItem('address')) this.address = sessionStorage.getItem('address')
    if (sessionStorage.getItem('category')) this.category = sessionStorage.getItem('category')
    if (sessionStorage.getItem('firstCategory')) this.firstCategory = sessionStorage.getItem('firstCategory')
    if (sessionStorage.getItem('secondCategory')) this.secondCategory = sessionStorage.getItem('secondCategory')
    if (sessionStorage.getItem('auditType')) this.auditType = sessionStorage.getItem('auditType')
    if (sessionStorage.getItem('reviewedById')) this.reviewedById = sessionStorage.getItem('reviewedById')
    if (sessionStorage.getItem('shelfStatus')) this.shelfStatus = sessionStorage.getItem('shelfStatus')
    if (sessionStorage.getItem('orderData')) this.orderData = JSON.parse(sessionStorage.getItem('orderData'))
    this.getPageList()
    this.getBrandCategoryList()
    this.getSelectCheckList()
    this.getSysUserList()
  },
  mounted () { },
  methods: {
    async getPageList () {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        name: this.name,
        status: this.status,
        fullName: this.fullName,
        sendSample: this.sendSample,
        address: this.address,
        category: this.category,
        auditType: this.auditType,
        firstCategory: this.firstCategory,
        secondCategory: this.secondCategory,
        reviewedById: this.reviewedById,
        shelfStatus: this.shelfStatus,
        ...this.orderData
      }
      let { data: res } = await this.$http.post('/cyberStar/getPageList', params)
      if (res.code === '200') {
        this.tableData = res.data.records
        this.tableData.forEach(item => {
          if (item.photo) {
            item.photoList = item.photo.split(',')
            item.photoSrc = item.photo.split(',')[0]
          } else {
            item.photorSrc = ''
            item.photoList = []
          }
        })
        this.total = parseInt(res.data.total)
      }
    },
    getBrandCategoryList () {
      this.$http.post('/brandCategory/getCategoryByType', { type: '5', level: '1' }).then(res => {
        if (res.data.code === '200') {
          this.brandCategoryList = res.data.data
          if (this.firstCategory) this.changOne(this.firstCategory)
        }
      })
    },
    getBrandName (n) {
      let name = ''
      this.brands.forEach(item => {
        if (item.id === n) {
          name = item.name
        }
      })
      return name
    },
    getCategory (n, m) {
      let name = ''
      let name1 = []
      let list = n ? n.split(',') : []
      const list1 = m ? m.split(',') : []
      this.brandCategoryList.forEach(item => {
        list.forEach(i => {
          if (i === item.id) {
            name = item.name
          }
          item.childList.forEach(j => {
            if (list1.includes(j.id)) {
              name1.push(j.name)
            }
          })
        })
      })
      return name + '/' + name1.join(',')
    },
    getSelectCheckList () {
      this.$http
        .post('/auditReason/getList', { type: '3' })
        .then((res) => {
          if (res.data.code === '200') {
            this.selectCheckList = res.data.data
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    reset () {
      this.name = ''
      this.status = ''
      this.fullName = ''
      this.sendSample = ''
      this.address = ''
      this.category = ''
      this.firstCategory = ''
      this.secondCategory = ''
      this.auditType = ''
      this.reviewedById = ''
      this.shelfStatus = ''
      this.orderData = {
        clientTimeOrder: '',
        serverTimeOrder: ''
      }
      this.getPageList()
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    selectRow (selection) {
      this.selectData = selection
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    add () {
      this.$router.push('/cyberStarDetail')
    },
    edit (id) {
      this.$router.push({
        name: 'CyberStarDetail',
        params: {
          id,
          type: 'edit'
        }
      })
    },
    deleteMore () {
      this.$confirm(`确认删除选中的${this.selectData.length}条数据?`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        let ids = this.selectData.map(item => item.id)
        ids = ids.join(',')
        this.$http.post('/cyberStar/batchDelete', { ids }).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    exportAll () {
      this.$confirm(`确认导出数据?`, '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.exportLoading = true
        let params = {
          name: this.name,
          status: this.status,
          fullName: this.fullName,
          sendSample: this.sendSample,
          address: this.address,
          category: this.category,
          firstCategory: this.firstCategory,
          secondCategory: this.secondCategory,
          auditType: this.auditType,
          reviewedById: this.reviewedById,
          shelfStatus: this.shelfStatus
        }
        this.$http.post('/cyberStar/exportData', params, { responseType: 'blob' }).then(res => {
          const link = document.createElement('a')
          let blob = new Blob([res.data], { type: 'application/x-excel' })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = '导出数据.xlsx'
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
          this.$message.success('导出成功')
          this.exportLoading = false
        }).catch(() => {
          this.exportLoading = false
          this.$message.success('导出失败')
        })
      }).catch(() => {
        this.$message.info('取消导出')
      })
    },
    sortChange (column) {
      this.orderData = {
        clientTimeOrder: '',
        serverTimeOrder: ''
      }
      if (column.prop === 'clientTime') this.orderData.clientTimeOrder = column.order ? column.order === 'descending' ? '2' : '1' : ''
      if (column.prop === 'serverTime') this.orderData.serverTimeOrder = column.order ? column.order === 'descending' ? '2' : '1' : ''
      this.currentPage = 1
      this.getPageList()
    },
    selectRemark (val) {
      this.verifyForm.reason = val.join(',')
    },
    verifySelect () {
      this.verifyForm.reason = ''
    },
    verifyMore () {
      this.checkList = []
      this.dialogShow = true
      let list = this.selectData.map(item => item.id)
      this.ids = list.join(',')
    },
    verify (id, status, reason) {
      this.checkList = []
      this.dialogShow = true
      this.ids = id
      this.verifyForm.status = status
      this.verifyForm.reason = reason
    },
    confirm () {
      this.$refs.verifyForm.validate(val => {
        if (val) {
          if (this.verifyForm.status !== '3') {
            this.verifyForm.reason = ''
          }
          let params = JSON.parse(JSON.stringify(this.verifyForm))
          params.ids = this.ids
          this.$http.post('/cyberStar/audit', params).then(res => {
            if (res.data.code === '200') {
              this.dialogShow = false
              this.getPageList()
              this.$message.success(res.data.msg)
              this.checkList = []
            }
          })
        }
      })
    },
    cancel () {
      this.dialogShow = false
      this.verifyForm = {
        status: '',
        reason: ''
      }
    },
    deleteInfo (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/cyberStar/delete', { id }).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    },
    upAndDown (id, shelfStatus) {
      let tip = ''
      let status = ''
      if (!shelfStatus || shelfStatus === '2') {
        tip = '确定上架该产品?'
        status = '1'
      } else {
        tip = '确定下架该产品?'
        status = '2'
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http
          .post('/cyberStar/modifyShelfStatus', { id, shelfStatus: status })
          .then((res) => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => {
          })
      })
    },
    onlinePreview (id) {
      this.onlineUrl = `/pages/supplier/product?id=${id}&type=5`
      this.onlineShow = true
    },
    qrPreview () {
      this.previewShow = true
    },
    getUrl (id) {
      this.$alert(`/pages/brand/cyberStar?id=${id}&type=5`, '查看链接', {
        confirmButtonText: '确定'
      })
    },
    checkRejectReason (reason) {
      this.$alert(reason, '驳回原因', {
        confirmButtonText: '确定'
      })
    },
    getSendSample (type) {
      const item = this.sendSamples.filter(item => item.id === type)[0]
      if (item) return item.name
      return ''
    },
    getSysUserList () {
      this.$http.get('/api/user/getSysUserList').then((res) => {
        this.sysUserList = res.data.data || []
      })
    },
    changOne (val) {
      this.categoryByTypeList = val ? this.brandCategoryList.find((item) => item.id === val).childList : []
    }
  }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/cyberStar/index.vue